'use strict';

var defaults = require('../../defaults/Defaults');
require('./KayleeService');
require('./RoomService');
var log = require('../../log/Log').channel('StartController');

// This is used by browser build to prevent the back button from popping through
// router states that won't load after authentication is lost. It needs to be
// global to the module because the controller will get re-initialized during
// unauthentication.
var startHistoryIndex = null;

angular.module('inara').controller('StartController', StartController);

StartController.$inject = ['$scope', '$state', '$timeout', 
                           '$ionicHistory', 'RoomService', 'KayleeService',
                           'ViewStateService', '$window', 'CallsService',
                           '$ionicModal', '$q', 'gettextCatalog'];

function StartController($scope, $state, $timeout, 
                         $ionicHistory, RoomService, KayleeService,
                         ViewStateService, $window, CallsService,
                         $ionicModal, $q, gettextCatalog) {
    var vm = this;
    var loginDialogScope = $scope.$new(true);
    var loginDialog = null;
    var loginDialogHidePromise = null;
    var ignoreNextUnauth = false;
    var connectTimeout = null;
    var timeBeforeStaticSpinner = 15000;
    var previousAnyDisconnected = false;

    log.info('initializing');
    loginDialogScope.portalName = defaults.mal.name;
    loginDialogScope.getPasswordPlaceholder = function() {
        /// Placeholder for password field
        return gettextCatalog.getString('Password');
    };
    loginDialogScope.getEmailPlaceholder = function() {
        /// Placeholder for email address field
        return gettextCatalog.getString('Email Address');
    };
    loginDialogScope.login = function(email, password) {
        loginDialogScope.errorMessage = null;
        loginDialogScope.processing = true;
        signOutIfNeeded()
            .finally(function() {
                KayleeService.signInWithEmailAndPassword(email, password)
                    .then(function(fbUser) {
                        log.debug('logged in as ' + fbUser.email);
                    })
                    .catch(function(error) {
                        loginDialogScope.processing = false;
                        log.debug('login error: ' + JSON.stringify(error, null, 4));

                        var errorMessages = {
                            'auth/invalid-email': 
                                /// Authentication error message for remote control/UI preview
                                gettextCatalog.getString('That is not a valid email address.'),
                            'auth/user-disabled': 
                                /// Authentication error message for remote control/UI preview
                                gettextCatalog.getString('This account has been disabled.'),
                            'auth/user-not-found': 
                                /// Authentication error message for remote control/UI preview
                                gettextCatalog.getString('There is no account for that email address.'),
                            'auth/wrong-password': 
                                /// Authentication error message for remote control/UI preview
                                gettextCatalog.getString('The password was incorrect.'),
                            'default': 
                                /// Authentication error message for remote control/UI preview
                                gettextCatalog.getString('We are having trouble logging you in right now.'),
                        };

                        if (error.code && errorMessages.hasOwnProperty(error.code)) {
                            loginDialogScope.errorMessage = errorMessages[error.code];
                        } else {
                            loginDialogScope.errorMessage = errorMessages['default'];
                        }
                    });
        });

        function signOutIfNeeded() {
            if (KayleeService.isAuthenticated()) {
                var deferred = $q.defer();
                ignoreNextUnauth = true;
                KayleeService.signOut().then(function() {
                    deferred.resolve();
                }).catch(function() {
                    deferred.reject();
                });
                return deferred.promise;
            }
            return $q.resolve();
        }
    };
    /// Status message for Mira Connect startup
    vm.message = gettextCatalog.getString('Initializing...');
    vm.url = null;
    vm.company = null;
    vm.site = null;
    vm.room = null;
    vm.spinnerLongRunning = false;
    vm.setup = function() {
        $ionicHistory.nextViewOptions({ disableBack: true });
        RoomService.enterSetup();
    };
    vm.getViewTitle = function() {
        /// Title bar on Mira Connect startup screen
        return gettextCatalog.getString('{{inaraName}} Starting', { inaraName: defaults.inara.name });
    };
    vm.getSetupButtonLabel = function() {  
        return gettextCatalog.getString('Start Setup');
    };
    vm.isBrowser = function() {
        return process.env.appEnv === 'browser';
    };
    vm.showSetupButton = function() {
        var controller = RoomService.getController();
        var state = RoomService.getState();
        return !controller || 
               !controller.$isPaired() ||
               state === 'unauthenticated' ||
               state === 'roomLoading' ||
               state === 'roomLoaded' ||
               state === 'roomOffline';
    };
    vm.onUrlClicked = function() {
        if (process.env.appEnv === 'browser') {
            // notify parent window of remote control that a URL was clicked
            $window.parent.postMessage(JSON.stringify({ message: 'url-clicked', url: vm.url} ),
                $window.location.origin);            
        }
    };

    $scope.$on('$stateChangeSuccess', onStateChanged);

    function onStateChanged(event, toState, toParams, fromState, fromParams) {
        if (fromState.name !== 'start' && toState.name === 'start') {
            log.debug('transitioned to start state, registering for RoomService state changed events');
            RoomService.onStateChanged(onRoomServiceStateChanged);
            vm.spinnerLongRunning = false;
        } 
        else if (fromState.name === 'start' && toState.name !== 'start' && !toState.name.startsWith('info')) {
            log.debug('transitioned out of start state, unregistering for RoomService state changed events');
            RoomService.offStateChanged(onRoomServiceStateChanged);
            $ionicHistory.clearHistory();
            $ionicHistory.clearCache();
            if (connectTimeout !== null) $timeout.cancel(connectTimeout);
            connectTimeout = null;
        }
    }

    function goToState(newState) {
        if (!$state.is('update') && !$state.is('factoryInstall')) {
            $state.go(newState);
        } else {
            log.debug('updating; can\'t transition to state ' + newState);
        }
    }

    function onRoomServiceStateChanged(state) {
        if (!$state.is('start')) {
            log.error('received room service state events when not in this state');
            log.debug('$state.current = ' + JSON.stringify($state.current, null, 4));
            return;
        }

        switch (state) {
            case 'start':
            case 'documentLoading':
            case 'documentLoaded':
                vm.room = null;
                vm.site = null;
                vm.company = null;
                vm.spinnerLongRunning = false;
                /// Status message on Mira Connect startup screen
                vm.message = gettextCatalog.getString('Starting {{inaraName}}...',
                    { inaraName: defaults.inara.name });
                vm.url = null;
                if (process.env.appEnv === 'browser' &&
                    state === 'documentLoaded') {
                    startHistoryIndex = $window.history.length;
                }
                break;
            case 'deviceLoading':
            case 'deviceLoaded':
            case 'waitingForConnection':
                /// Status message on Mira Connect startup screen
                vm.message = gettextCatalog.getString('Checking connection to {{portalName}}...',
                    { portalName: defaults.mal.name });
                break;
            case 'waitingForAuth':
                /// Status message on Mira Connect startup screen
                vm.message = gettextCatalog.getString('Authenticating to {{portalName}}...',
                    { portalName: defaults.mal.name });
                break;
            case 'unauthenticated':
                if (process.env.appEnv === 'browser' &&
                    angular.isDefined($state.params) &&
                    angular.isDefined($state.params.roomId)) {
                    // Remote control session
                    if (KayleeService.isAuthenticated()) {
                        // The unauthenticated state is overloaded to include the case where a user
                        // doesn't have permissions for the room. We check isAuthenticated() to
                        // determine which case this is.
                        var room = RoomService.getRoom();

                        if (room === null) {
                            var anonUserMsg = gettextCatalog.getString('This remote control ' +
                                    'session has expired. To start remote control again, scan or ' +
                                    'enter the code shown on {{controller}} in the room.',
                                    { controller: defaults.inara.name });
                            var anonUserUrl = 'https://www.miraconnect.me';
                            KayleeService.getUser().$loaded().then(function(user) {
                                if (KayleeService.isAuthenticatedAsAnonymousRemoteControl(user)) {
                                    vm.message = anonUserMsg;
                                    vm.url = anonUserUrl;
                                } else {
                                    /// Status message on Mira Connect startup screen
                                    vm.message = gettextCatalog.getString('The user {{userEmail}}' +
                                        ' does not have permission to access to this room.',
                                        { userEmail: user.email });
                                    loginDialogScope.errorMessage = vm.message;
                                    showLoginDialog();
                                }
                            }).catch(function(userError) {
                                vm.message = anonUserMsg;
                                vm.url = anonUserUrl;
                            });
                        }
                    } else if (!ignoreNextUnauth) {
                        // When logging in, we first logout any existing user to force an
                        // authentication change in RoomService (so we can re-display the 
                        // permissions error message if needed). We can ignore this unauthentication
                        // if it originated from the login dialog.

                        /// Status message on Mira Connect startup screen
                        vm.message = gettextCatalog.getString(
                            'Please log in to {{portalName}} to reconnect.',
                            { portalName: defaults.mal.name });
                        loginDialogScope.errorMessage = null;
                        showLoginDialog();
                    }
                    ignoreNextUnauth = false;
                    if (process.env.appEnv === 'browser') {
                        $timeout(function() {
                            $window.addEventListener('popstate', onWindowPopState);
                        }, 500);
                    }
                } else {
                    /// Status message on Mira Connect startup screen
                    vm.message = gettextCatalog.getString('Unable to connect to {{portalName}}.',
                        { portalName: defaults.mal.name });
                }
                break;
            case 'authenticated':
                /// Status message on Mira Connect startup screen
                vm.message = gettextCatalog.getString('Authenticated with {{portalName}}.',
                    { portalName: defaults.mal.name });
                if (process.env.appEnv === 'browser') {
                    if (loginDialog !== null) {
                        loginDialogHidePromise = loginDialog.remove();
                        loginDialogHidePromise.finally(function() {
                            loginDialog = null;
                            loginDialogScope.processing = false;
                            loginDialogHidePromise = null;
                        });
                    }
                    $window.removeEventListener('popstate', onWindowPopState);
                }
                break;
            case 'kayleeLoading':
                /// Status message on Mira Connect startup screen
                vm.message = gettextCatalog.getString('Loading {{portalName}} info...',
                    { portalName: defaults.mal.name });
                break;
            case 'kayleeLoaded':
                /// Status message on Mira Connect startup screen
                vm.message = gettextCatalog.getString('{{portalName}} info loaded.',
                    { portalName: defaults.mal.name });
                break;
            case 'waitingForKayleeEnabled':
                /// Status message on Mira Connect startup screen
                vm.message = gettextCatalog.getString(
                    '{{portalName}} is temporarily under maintenance and will reconnect shortly.',
                    { portalName: defaults.mal.name });
                break;
            case 'waitingForKayleeVersion':
                /// Status message on Mira Connect startup screen
                vm.message = gettextCatalog.getString(
                    '{{inaraName}} needs a software update to continue. ' +
                    'Please contact the room administrator.', { inaraName: defaults.inara.name });
                break;
            case 'controllerLoading':
                /// Status message on Mira Connect startup screen
                vm.message = gettextCatalog.getString('Loading controller data...');
                break;
            case 'controllerLoaded':
                /// Status message on Mira Connect startup screen
                vm.message = gettextCatalog.getString('Loaded controller data.');
                if (process.env.appEnv !== 'browser' &&
                    RoomService.getController().settings.factoryInstallMode) {
                    goToState('factoryInstall');
                }
                break;
            case 'controllerUnpaired':
                if (process.env.appEnv !== 'browser' &&
                    !RoomService.getController().settings.factoryInstallMode) {
                    /// Status message on Mira Connect startup screen
                    vm.message = gettextCatalog.getString('Controller not paired with room. Starting setup...');
                    log.info('Controller not paired with room. Starting setup...');
                    goToState('setup.start');
                }
                break;
            case 'roomLoading':
                /// Status message on Mira Connect startup screen
                vm.message = gettextCatalog.getString('Loading room data...');
                break;
            case 'roomLoaded':
                /// Status message on Mira Connect startup screen
                vm.message = gettextCatalog.getString('Loaded room data.');
                updatePairingInfo();
                break;
            case 'roomOffline':
                queryEquipmentControlState();
                 // need this in case user comes back from system info view
                updatePairingInfo();
                break;
            case 'roomOnline':
                if (process.env.appEnv !== 'browser' &&
                    RoomService.getController().settings.factoryInstallMode) {
                    goToState('factoryInstall');
                } else {
                    /// Status message on Mira Connect startup screen
                    vm.message = gettextCatalog.getString('Room online. Going to control...');

                    if (CallsService.getActiveCalls().length > 0) {
                        goToState(ViewStateService.getInCallState());
                    }
                    else {
                        goToState(ViewStateService.getInitialState());                    
                    }
                }

                break;
            default:
                log.error('unhandled RoomService state: ' + state);
                break;
        }
    }

    function onWindowPopState(event) {
        // If we are unauthenticated, prevent the back button from popping 
        // through the Ionic history stack. Jump to the point in the browser
        // history stack where we initialized the start state.
        if (startHistoryIndex === null ||
            RoomService.getState() !== 'unauthenticated') return;
        var index = startHistoryIndex;
        startHistoryIndex = null;
        $window.removeEventListener('popstate', onWindowPopState);
        $window.history.go(index - $window.history.length);
    }

    function updatePairingInfo() {
        vm.room = RoomService.getRoom();
        vm.site = KayleeService.getSite(vm.room.siteId);
        vm.company = KayleeService.getCompany(vm.room.companyId);
    }

    function showLoginDialog() {
        $ionicModal.fromTemplateUrl(
            'loginDialog.html', 
            { 
                backdropClickToClose: false,
                hardwareBackButtonClose: false,
                scope: loginDialogScope
            }).then(function(dlg) {
                if (loginDialogHidePromise !== null) {
                    loginDialogHidePromise.finally(function() {
                        loginDialog = dlg;
                        show();
                    });
                }
                else {
                    loginDialog = dlg;
                    show();
                }
            }).catch(function() {
                log.error('error creating login dialog');
            });

        function show() {
            loginDialog.show().then(function() {
                $timeout(function() {
                    var emailField = loginDialog.el.querySelector('#email');
                    emailField.focus();
                    emailField.select();
                }, 20);
            });
        }
    }

    function queryEquipmentControlState() {
        if (RoomService.getState() !== 'roomOffline') return;

        var room = RoomService.getRoom();
        var equipmentList = room ? room.$getEquipment() : null;
        var anyDisconnected = false;

        if (equipmentList.length === 0) {
            /// Status message on Mira Connect startup screen
            vm.message = gettextCatalog.getString(
                'Add equipment to the room on {{portalName}}: {{portalAddress}}',
                { portalName: defaults.mal.name, portalAddress: defaults.mal.webAddress });
            vm.spinnerLongRunning = true;
        } else {
            var needsSetup = false;

            for (var i = 0; i < equipmentList.length; i++) {
                if (equipmentList[i].connectState === 'controlFailed') {
                    needsSetup = true;
                } else if (equipmentList[i].connectState === 'connectFailed' ||
                    equipmentList[i].connectState === 'connecting') {
                    anyDisconnected = true;
                }
            }

            if (needsSetup) {
                /// Status message on Mira Connect startup screen
                vm.message = gettextCatalog.getString(
                    'Some of the equipment requires further setup on {{portalName}}: {{portalAddress}}',
                    { portalName: defaults.mal.name, portalAddress: defaults.mal.webAddress });
                vm.spinnerLongRunning = true;
            } else {
                /// Status message on Mira Connect startup screen
                vm.message = gettextCatalog.getString('Connecting to equipment. If this takes more ' +
                    'than a minute, please contact the room administrator.');
                if (anyDisconnected && !previousAnyDisconnected) {
                    if (connectTimeout !== null) $timeout.cancel(connectTimeout);
                    connectTimeout = null;
                }
                if (connectTimeout === null) {
                    vm.spinnerLongRunning = false;
                    connectTimeout = $timeout(function() {
                        vm.spinnerLongRunning = true;
                    }, timeBeforeStaticSpinner);
                }
            }
        }
        previousAnyDisconnected = anyDisconnected;

        $timeout(queryEquipmentControlState, 1000);
    }
}

module.exports = StartController;
